import { SchemaType } from '../type';
export const schema = {
    id: 'collection',
    name: get => `数据源（${get('name')}）`,
    type: SchemaType.Indivisible,
};
